<script>
import def from "./checkbox";
export default {
  extends: def
};
</script>
